// Get CSRF token from <meta> tag
export function getCSRFToken() {
  const csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
  return csrfTokenMeta ? csrfTokenMeta.content : null;
}
